export const WINDOW_OPTIONS_HOURS = [ 1, 2, 3, 6, 12, 24, 48 ];
export const SPEED_OPTIONS = [ 0.5, 1, 2, 4 ];
export const DEFAULT_WINDOW_HOURS = 2;
export const DEFAULT_SPEED = 1;
export const STALE_AFTER_MINUTES = 25;
export const CLOCK_TICK_SECONDS = 15;
export const REFRESH_INTERVAL_SECONDS = 60;
export const BASE_FRAME_MS = 500;
export const LAST_FRAME_PAUSE_MS = 1500;
export const DOUBLE_TAP_ZOOM = 2.5;
export const KEYBOARD_ZOOM_STEP = 1.25;
export const PRELOAD_CONCURRENCY = 8;
export const GIF_OPTIONS_HOURS = [ 1, 2, 4, 8 ];
export const GIF_MAX_SIZE_PX = 480;
export const GIF_FRAME_MS = 500;
export const GIF_LAST_FRAME_MS = 1500;
export const TOAST_MS = 2000;
